import { html } from 'lit';
import { Menu } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-menu')
export class PdsIconMenu extends PdsIcon {
  @state()
  icon = Menu;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
